import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getPayRateTimeseriesCsv } from 'api/pulse/payRateTimeseries'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function usePayRateTimeseriesDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_pay_rate_timeseries', {
        filters: query,
      })
      const data = await getPayRateTimeseriesCsv(query)
      fileDownload(data, 'pay_rate_timeseries.csv')
    },
  })
}
